import { useDispatch, useSelector } from 'react-redux';
import CampaignHeader from './CampaignHeader';
import React from 'react';
import { goToCampaign } from '../actions';
function CampaignBannerList({ campaigns }) {
    if (!campaigns || campaigns.length < 1)
        return null;
    const dispatch = useDispatch();
    const isMobile = useSelector((state) => state.ui.isMobile);
    return (React.createElement("div", { className: "campaign-banner" }, campaigns.map((campaign, index) => {
        const { title, background_color, image, title_text_color } = campaign;
        return (React.createElement(CampaignHeader, { key: index, title: title, image: isMobile ? image.mobile : image.desktop, backgroundColor: background_color, textColor: title_text_color, type: "banner", onClick: () => dispatch(goToCampaign(campaign)) }));
    })));
}
export default CampaignBannerList;
